import css from 'styled-jsx/css'
import React from 'react'
import { commonShared } from 'com-ui/utilities/iconPath'

export default function AutoLogin() {
  return (
    <div className="signup-success text-center">
      <div className="check-mark">
        <img src={commonShared(`loading-animation`, 'gif')} alt="registry success" height="130px" width="130px" />
      </div>
      <h6 className="h6 my-3 pt-3">Hang in there, we’re completing your account..</h6>
      <style jsx>{style}</style>
    </div>
  )
}

const style = css`
  .signup-success {
    padding: 32px;
    box-shadow: var(--depth-64);
    background-color: var(--white-100);
    border-radius: 16px;
    max-width: 520px;
    margin: auto;
    margin-top: 50px;
  }
  .check-mark {
    margin-top: 20px;
  }
`
